module.exports = __webpack_public_path__ + "static/media/logoTrionix.a7328c1b.png";